import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "max-one-line"
}
const _hoisted_2 = {
  key: 1,
  class: "input-quote-message-h5 max-one-line"
}
const _hoisted_3 = { class: "input-quote-sender-h5" }
const _hoisted_4 = { class: "max-one-line" }

import vue from '../../../../adapter-vue';
import TUIChatEngine, {
  TUIStore,
  StoreName,
  TUITranslateService,
  IMessageModel,
} from '../../../../@aidesk/uikit-engine';
import Icon from '../../../common/Icon.vue';
import closeIcon from '../../../../assets/close-quote-icon.svg';
import { isPC,isH5 } from '../../../../utils/env';
import { transformTextWithKeysToEmojiNames } from '../../emoji-config';
import { InputDisplayType } from '../../../../interface';
import { getQuoteContentForDesk } from '../../../../utils/utils';
import { MessageQuoteTypeEnum } from '../../message-list/message-elements/message-quote/interface';
interface IProps {
  displayType?: InputDisplayType;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    displayType: { default: 'editor' }
  },
  emits: ['getQuoteMessageCloudCustomData'],
  setup(__props: any, { emit: __emit }) {

const { ref, computed, onMounted, onUnmounted } = vue;

const props = __props;

const TYPES = TUIChatEngine.TYPES;
const quoteMessage = ref<IMessageModel>();
const quoteMessageType = ref<number>(0);

const emits = __emit;

onMounted(() => {
  TUIStore.watch(StoreName.CHAT, {
    quoteMessage: onQuoteMessageUpdated,
  });
});

onUnmounted(() => {
  TUIStore.unwatch(StoreName.CHAT, {
    quoteMessage: onQuoteMessageUpdated,
  });
});

const quoteContentText = computed(() => {
  let _quoteContentText;
  switch (quoteMessage.value?.type) {
    case TYPES.MSG_TEXT:
      _quoteContentText = transformTextWithKeysToEmojiNames(
        quoteMessage.value.payload?.text,
      );
      quoteMessageType.value = MessageQuoteTypeEnum.TYPE_TEXT;
      break;
    case TYPES.MSG_IMAGE:
      _quoteContentText = TUITranslateService.t('TUIChat.图片');
      quoteMessageType.value = MessageQuoteTypeEnum.TYPE_IMAGE;
      break;
    case TYPES.MSG_AUDIO:
      _quoteContentText = TUITranslateService.t('TUIChat.语音');
      quoteMessageType.value = MessageQuoteTypeEnum.TYPE_SOUND;
      break;
    case TYPES.MSG_VIDEO:
      _quoteContentText = TUITranslateService.t('TUIChat.视频');
      quoteMessageType.value = MessageQuoteTypeEnum.TYPE_VIDEO;
      break;
    case TYPES.MSG_FILE:
      _quoteContentText = TUITranslateService.t('TUIChat.文件');
      quoteMessageType.value = MessageQuoteTypeEnum.TYPE_FILE;
      break;
    case TYPES.MSG_CUSTOM:
      _quoteContentText = getQuoteContentForDesk(quoteMessage.value);
      quoteMessageType.value = MessageQuoteTypeEnum.TYPE_CUSTOM;
      break;
    case TYPES.MSG_FACE:
      _quoteContentText = TUITranslateService.t('TUIChat.表情');
      quoteMessageType.value = MessageQuoteTypeEnum.TYPE_FACE;
      break;
    case TYPES.MSG_MERGER:
      _quoteContentText = TUITranslateService.t('TUIChat.聊天记录');
      quoteMessageType.value = MessageQuoteTypeEnum.TYPE_MERGER;
      break;
    case TYPES.MSG_STREAM:
      _quoteContentText = quoteMessage.value.payload.markdown || '';
      quoteMessageType.value = MessageQuoteTypeEnum.TYPE_CUSTOM;
      break;
    default:
      _quoteContentText = TUITranslateService.t('TUIChat.消息');
      quoteMessageType.value = MessageQuoteTypeEnum.TYPE_NONE;
      break;
  }
  return _quoteContentText;
});

function cancelQuote() {
  TUIStore.update(StoreName.CHAT, 'quoteMessage', {
    message: undefined,
    type: 'quote',
  });
}

function onQuoteMessageUpdated(options?: {
  message: IMessageModel;
  type: string;
}) {
  if (options && options.message && options.type === 'quote') {
    quoteMessage.value = options.message;
    const quoteMessageCloudCustomData = JSON.stringify({
      messageReply: {
        messageAbstract: quoteContentText.value,
        messageID: quoteMessage.value.ID,
        messageSender: quoteMessage.value.from,
        messageTime: quoteMessage.value.time,
        messageType: quoteMessageType.value,
      }
    });
    emits('getQuoteMessageCloudCustomData', quoteMessageCloudCustomData);
  } else {
    quoteMessage.value = undefined;
    emits('getQuoteMessageCloudCustomData', undefined);
  }
}

return (_ctx: any,_cache: any) => {
  return (Boolean(_unref(quoteMessage)) && props.displayType !== 'audio')
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass({
      'input-quote-container': true,
      'input-quote-container-h5': _unref(isH5),
    })
      }, [
        _createElementVNode("div", {
          class: _normalizeClass((!_unref(isPC)) ? 'input-quote-content-h5' :'input-quote-content')
        }, [
          (_unref(isPC))
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString((_unref(quoteMessage).nick || _unref(quoteMessage).from)+ ': ' + _unref(quoteContentText)), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, _toDisplayString((_unref(quoteMessage).nick || _unref(quoteMessage).from)), 1),
                _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(quoteContentText)), 1)
              ])),
          _createVNode(Icon, {
            class: "input-quote-close-icon",
            file: _unref(closeIcon),
            width: "14px",
            height: "14px",
            onOnClick: cancelQuote
          }, null, 8, ["file"])
        ], 2)
      ], 2))
    : _createCommentVNode("", true)
}
}

})